import { useQuery } from 'react-query';

import { noteService } from 'services';

export default function useQueryTypesAction() {
  return useQuery(['TypesAction'], () => noteService.getTypesAction(), {});
}
